// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1ldyN","imageUploader":"EGiftCard_imageUploader__SxQwl"};